import { generateMedia } from 'styled-media-query'
import breakpoints from '../shared/responsive'

// Styled Media Query
// https://github.com/morajabi/styled-media-query

// Has 3 main methods to generate media queries:
//   - lessThan(breakpoint | size)
//   - greaterThan(breakpoint | size)
//   - between(firstBreakpoint | firstSize, lastBreakpoint | lastSize)

let bps = breakpoints().breakpoints

bps = Object.keys(bps).reduce((acc, key) => {
  acc[key] = bps[key] + 'px'
  return acc
}, {})

export default generateMedia(bps)
